import { User } from '../context/authContext';

export type UserAbilitySubject = User & { kind: 'User' };
export const createUserAbilitySubject = (user: User): UserAbilitySubject => {
  return { ...user, kind: 'User' };
};
